"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialDeviceT = exports.SerialDevice = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class SerialDevice {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSerialDevice(bb, obj) {
        return (obj || new SerialDevice()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSerialDevice(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SerialDevice()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    port(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    name(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startSerialDevice(builder) {
        builder.startObject(2);
    }
    static addPort(builder, portOffset) {
        builder.addFieldOffset(0, portOffset, 0);
    }
    static addName(builder, nameOffset) {
        builder.addFieldOffset(1, nameOffset, 0);
    }
    static endSerialDevice(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSerialDevice(builder, portOffset, nameOffset) {
        SerialDevice.startSerialDevice(builder);
        SerialDevice.addPort(builder, portOffset);
        SerialDevice.addName(builder, nameOffset);
        return SerialDevice.endSerialDevice(builder);
    }
    unpack() {
        return new SerialDeviceT(this.port(), this.name());
    }
    unpackTo(_o) {
        _o.port = this.port();
        _o.name = this.name();
    }
}
exports.SerialDevice = SerialDevice;
class SerialDeviceT {
    constructor(port = null, name = null) {
        this.port = port;
        this.name = name;
    }
    pack(builder) {
        const port = (this.port !== null ? builder.createString(this.port) : 0);
        const name = (this.name !== null ? builder.createString(this.name) : 0);
        return SerialDevice.createSerialDevice(builder, port, name);
    }
}
exports.SerialDeviceT = SerialDeviceT;
